import clsx from "clsx";
import React from "react";
import {
  getBezierPath,
  getMarkerEnd,
  getSmoothStepPath,
  ReactFlowProvider,
} from "react-flow-renderer";

import "./index.css";

const CustomEdge = (edge) => {
  const { sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition } =
    edge;
  const edgePath = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const markerEnd = getMarkerEnd(edge.arrowHeadType, edge.markerEndId);

  return (
    <ReactFlowProvider>
      <path
        id={edge.id}
        style={edge.style}
        className={clsx(
          "react-flow__edge-path",
          "edge",
          edge.data.isHighlighted && "highlighted"
        )}
        d={edgePath}
        markerEnd={markerEnd}
      />
      <text dy={-8}>
        <textPath
          href={`#${edge.id}`}
          startOffset="50%"
          textAnchor="middle"
          className="edge-label"
        >
          {edge.label}
        </textPath>
      </text>
    </ReactFlowProvider>
  );
};

export default CustomEdge;
